const {
	$each,
	$find,
	removeEl,
	getCookie,
	sendDataLayerEvent,
	showModal,
} = require("./ElevHelpers");
const ElevShared = require("../../../../shared/ElevShared");

const {
	modifyCart,
	addItemsToCart,
	showAddToCartModal,
	getTotalQuantity,
	canAddSubToCart,
	showAddBundleToCartModal,
	loadCartFromStorage,
	getSubscriptionPlaceholderName,
} = require("./CartUtil");
const {openModalByName} = require("./ModalUtil");

const {closeModalFromChild, getModalWrapperFromId} = require("./WfModalUtil");

const {onModalClose, onModalOpen} = require("./WfModalUtil");

const handleClassWalletBundleModal = require("./handleClassWalletBundleModal");

const {
	state,
	addNewSub,
	addToCartFunc,
	canAddSubRow,
	getSubDisplayPrice,
	loadSubsFromCart,
} = require("./EnrollHelpers");

const {track} = require("../../../core/util/Mixpanel");

const rowPriceConfig = {
	forceDecimal: false,
	unit: "shortUnit",
	includeDollarSign: true,
};

function setupModalButtons(wrapper, addStudentTriggerRow) {
	/* Reset the 'Add To Cart' button */
	const resetAddToCart = function(el) {
		el.classList.remove("checkout-btn");
		el.innerText = "Add To Cart";
		setupAddToCart(el);
	};

	/* Convert any button with 'Checkout' into 'Add to Cart' */
	const resetAddToCartButtons = function() {
		$each(wrapper, ".checkout-btn", resetAddToCart);
	};

	const setupKeepShopping = function(el) {
		el.addEventListener("click", function(e) {
			e.preventDefault();
			resetAddToCartButtons();
			closeModalFromChild(el);
		});
	};

	const displayAddToCartErrors = function(errorObj, alertDiv) {
		// turn error obj into an array - used an obj for built-in de-duplication
		const errors = Object.keys(errorObj);
		const contentEl = alertDiv.querySelector(".modal-alert-content");

		// clear current alert content
		contentEl.replaceChildren();

		// make it an error div
		alertDiv.classList.add("error");
		alertDiv.classList.remove("success");

		if (errors.length === 1) {
			const text = document.createTextNode(
				ElevShared.copyForStudentNameErrors(errors[0])
			);
			contentEl.appendChild(text);
			return;
		}

		const errorList = document.createElement("ul");
		for (let i = 0; i < errors.length; i++) {
			const errorRow = document.createElement("li");
			const errorText = document.createTextNode(
				ElevShared.copyForStudentNameErrors(errors[i])
			);
			errorRow.appendChild(errorText);
			errorList.appendChild(errorRow);
		}
		contentEl.appendChild(errorList);
	};

	const formatAddToCartSuccess = function(movedSubs) {
		if (!movedSubs.length) {
			return null;
		}

		let innerString = movedSubs[0].name;
		if (movedSubs.length === 2) {
			innerString += ` and ${movedSubs[1].name}`;
		} else if (movedSubs.length === 3) {
			innerString += `, ${movedSubs[1].name} and ${movedSubs[2].name}`;
		} else if (movedSubs.length > 1) {
			innerString += `, ${movedSubs[1].name}, and ${movedSubs.length - 2} more`;
		}

		const ucFirst = function(str) {
			str = str.toLowerCase();
			return str[0].toUpperCase() + str.slice(1);
		};

		let subscription =
			movedSubs[0].subType === "bundle"
				? "BA Bundle"
				: `${ucFirst(movedSubs[0].subType)} Subscription`;
		let have = "has";
		if (movedSubs.length > 1) {
			subscription += "s";
			have = "have";
		}
		return `Success! ${subscription} for ${innerString} ${have} been added to your cart`;
	};

	const setupAddToCart = function(el) {
		const trackCheckoutButtonClick = function() {
			track("Enrollment Checkout Button Clicked", {
				page: "enroll",
				enrollType: el.dataset.mixpanelEnrollType,
			});
			el.removeEventListener("click", trackCheckoutButtonClick);
		};

		// clear the event listener if it exists
		el.removeEventListener("click", trackCheckoutButtonClick);
		const addToCart = function(e) {
			e.preventDefault();
			const parent = el.closest(".modal-wrap");
			const alertDiv = $find(parent, ".modal-alert")[0];
			const valid = addToCartFunc();
			if (!valid) {
				track("Enrollment Failed to Add to Cart", {
					page: "enroll",
					enrollType: el.dataset.mixpanelEnrollType,
				});
				const errorObj = {};
				alertDiv.classList.remove("success");
				alertDiv.classList.add("error");

				for (let i = 0; i < state.newSubs.length; i++) {
					const sub = state.newSubs[i];
					const subEl = sub.el;
					const errors = sub.errors;
					if (errors.length) {
						const hasGradeError = errors.includes("E_NO_GRADE");
						if (hasGradeError) {
							subEl
								.getElementsByClassName("modal-dropdown")[0]
								.classList.add("error");
						}
						if (!hasGradeError || errors.length > 1) {
							subEl.getElementsByTagName("input")[0].classList.add("error");
						}

						for (let j = 0; j < errors.length; j++) {
							if (!errorObj.hasOwnProperty(errors[j])) {
								errorObj[errors[j]] = null;
							}
						}
					}
				}
				displayAddToCartErrors(errorObj, alertDiv);
			} else {
				track("Subscription Added to Cart", {
					page: "enroll",
					enrollType: el.dataset.mixpanelEnrollType,
				});
				alertDiv.classList.remove("error");
				const successText = formatAddToCartSuccess(state.movedSubs);
				if (successText) {
					alertDiv.classList.add("success");
					alertDiv.querySelector(
						".modal-alert-content"
					).innerText = successText;
				}
				// add an event listener to the checkout button to track the click event
				el.addEventListener("click", trackCheckoutButtonClick);
				el.innerText = "Checkout";
				el.classList.add("checkout-btn");
				el.closest(".w-form").classList.remove("has-many-rows");
				updateMovedToCart(state.movedSubs);
				hideAddStudentTrigger(addStudentTriggerRow);
				el.removeEventListener("click", addToCart);
			}
		};
		if (canAddSubRow()) {
			el.addEventListener("click", addToCart);
		} else {
			/* Show "View Cart" if user is already at max subscriptions */

			el.innerText = "View Cart";
			el.classList.add("checkout-btn");
		}
	};

	$each(wrapper, ".keep-shopping-btn", setupKeepShopping);
	$each(wrapper, ".add-to-cart-btn", setupAddToCart);

	return {resetAddToCartButtons};
}

function updateMovedToCart(movedSubs) {
	movedSubs.forEach(function(sub) {
		$each(sub.el, ".row-price, .tippy", function(el) {
			el.remove();
		});
		const nameContainer = sub.el.getElementsByClassName(
			"modal-input-wrapper"
		)[0];
		$each(nameContainer, "*", function(el) {
			el.remove();
		});
		$each(sub.el, ".modal-form-dropdown", function(el) {
			el.remove();
		});
		nameContainer.innerText = sub.name;
		nameContainer.classList.add("cart-sub-row");
	});
}

function addSubscriptionRow(wrapper, template) {
	const triggerRow = $find(wrapper, ".modal-form-row.add-student-trigger")[0];
	const parent = triggerRow.closest(".w-form");
	if (canAddSubRow()) {
		const sub = addNewSub(wrapper.dataset.enrollType);
		const newNode = template.cloneNode(true);
		setRowPrice(newNode, sub);
		sub.el = newNode;
		parent.insertBefore(newNode, triggerRow);
		setupSubRowListeners(newNode, sub, triggerRow);
		$find(newNode, "input")[0].focus();
	}

	if (state.newSubs.length > 1) {
		parent.classList.add("has-many-rows");
	}

	// disable addStudentTrigger if we've reached max subs
	if (!canAddSubRow()) {
		setTimeout(disableAddStudentTrigger, 0, triggerRow);
	}
}

function disableAddStudentTrigger(triggerRow) {
	triggerRow.classList.add("has-max-subs");
}

function enableAddStudentTrigger(triggerRow) {
	triggerRow.classList.remove("has-max-subs");
}

function hideAddStudentTrigger(triggerRow) {
	triggerRow.classList.add("ba11--hidden");
}

function showAddStudentTrigger(triggerRow) {
	triggerRow.classList.remove("ba11--hidden");
}

function setupSubRowListeners(row, subObj, triggerRow) {
	// tippy js settings
	const tippyEls = row.getElementsByClassName("tippy");
	window.tippy(Array.from(tippyEls), {
		// Use class or id
		animation: "scale", // See docs for more options (there are a few nice ones 😉)
		duration: 200, // Duration for ToolTip Animation
		arrow: true, // Add ToolTip Arrow
		delay: [0, 50], // First # = delay in, second # = delay out
		arrowType: "sharp", // Sharp or 'round' or remove for none
		theme: "light", // Dark is the default
		maxWidth: 220, // Max width in pixels for the tooltip
	});
	$each(row, ".modal-input.student-name", function(el) {
		el.addEventListener("blur", function(e) {
			if (e.srcElement) {
				subObj.name = e.srcElement.value;
			}
		});
	});

	if (subObj.subType === "bundle") {
		window.Webflow.require("dropdown").ready();

		const dropdownParent = row.getElementsByClassName("w-dropdown")[0];

		// Using some jQuery here because I know that it exists
		// due to webflow, and I need it to access the dropdown.
		// Without webflow, jQuery doesn't exist on this page
		const dropdownData = window.$(dropdownParent).data()[".wDropdown"];
		const dropdownLabel = dropdownParent.getElementsByClassName(
			"dropdown-label"
		)[0];
		dropdownData.links.each(function(i, link) {
			const grade = link.dataset.grade;
			link.addEventListener("click", function(e) {
				e.preventDefault();
				subObj.selectedBundles = [grade];
				dropdownData.selectedIdx = i;
				dropdownData.el.trigger("w-close");
				dropdownLabel.innerText = `Level ${grade}`;
			});
		});
	}

	$each(row, ".input-remove-icon", function(el) {
		const formEl = el.closest(".w-form");
		el.addEventListener("click", function(e) {
			row.remove();
			const index = state.newSubs.findIndex(function(obj) {
				return obj === subObj;
			});

			if (index > -1) {
				state.newSubs.splice(index, 1);
				if (index === 0) {
					const first = state.newSubs.find(Boolean);
					setRowPrice(first.el, first);
				}
			}

			if (state.newSubs.length <= 1) {
				formEl.classList.remove("has-many-rows");
			}
			enableAddStudentTrigger(triggerRow);
		});
	});
}

function setRowPrice(row, subObj) {
	const displayPrice = getSubDisplayPrice(subObj, rowPriceConfig);
	row.getElementsByClassName("row-price")[0].innerText = displayPrice;
}

function setupAddRow(trigger, wrapper, templateRow) {
	trigger.addEventListener("click", function(e) {
		e.preventDefault();
		addSubscriptionRow(wrapper, templateRow);
	});
}

function setupSubscriptionModal(id, wrapper) {
	const isInRect = function(mouseX, mouseY, rect) {
		const {left, right, top, bottom} = rect;
		return (
			mouseX >= left && mouseX <= right && mouseY >= top && mouseY <= bottom
		);
	};
	let didMouseDown = false;

	const innerWrap = wrapper.getElementsByClassName("modal-wrap")[0];
	const scrollContainer = wrapper.getElementsByClassName(
		"modal-scroll-container"
	);

	scrollContainer[0].addEventListener("mousedown", function(e) {
		didMouseDown = true;
	});
	innerWrap.addEventListener("click", function(e) {
		// prevent clicks bubbling to wrapper from the modal body
		// unless we clicked on the "X"
		if (
			!e.target.classList.contains("close-block") &&
			!e.target.classList.contains("close-image")
		) {
			e.stopPropagation();
		}
		didMouseDown = false;
	});
	wrapper.addEventListener("click", function(e) {
		// don't do anything special if we actually clicked the "X", otherwise trigger a click on the
		// "X" in order to preserve webflow functionalities
		const containerRect = scrollContainer[0].getBoundingClientRect();
		if (didMouseDown && !isInRect(e.clientX, e.clientY, containerRect)) {
			e.stopPropagation();
			return;
		}
		if (
			!e.target.classList.contains("close-block") &&
			!e.target.classList.contains("close-image")
		) {
			wrapper.getElementsByClassName("close-block")[0].click();
		}
		didMouseDown = false;
	});

	wrapper.addEventListener("mousedown", function(e) {
		const containerRect = scrollContainer[0].getBoundingClientRect();
		if (!isInRect(e.clientX, e.clientY, containerRect)) {
			didMouseDown = false;
		}
	});

	const headerEl = $find(innerWrap, ".modal-header")[0];
	const originalHeaderText = headerEl ? headerEl.textContent.trim() : "";

	const applyMaxSubsState = function() {
		loadSubsFromCart();
		if (!canAddSubRow()) {
			innerWrap.classList.add("has-max-subs");
			headerEl.innerHTML =
				"<h2>You have reached the maximum number of subscriptions.</h2>";
		} else {
			innerWrap.classList.remove("has-max-subs");
			headerEl.textContent = originalHeaderText;
		}
	};

	/* Change modal content if the user has reached maximum subscriptions for family account (currently 6) */
	applyMaxSubsState();

	const templateRow = $find(wrapper, ".modal-form-row.entry-row")[0].cloneNode(
		true
	);

	$find(wrapper, ".add-student-trigger .modal-form-input a").forEach(function(
		el
	) {
		setupAddRow(el, wrapper, templateRow);
	});
	const addStudentTriggerRow = $find(
		wrapper,
		".modal-form-row.add-student-trigger"
	)[0];

	const {resetAddToCartButtons} = setupModalButtons(
		wrapper,
		addStudentTriggerRow
	);

	const onOpen = function(wrapperEl) {
		// Re-check max subs from current cart so message shows for bundles/subs added after page load
		applyMaxSubsState();
		// add class to body
		document.body.classList.add("wf-modal--open");
		// clear old data since subs in the modals do not persist
		state.newSubs = [];
		$each(wrapperEl, ".entry-row", function(el) {
			removeEl(el);
		});

		// add back the inital row with the correct listeners on it
		addSubscriptionRow(wrapper, templateRow);

		// make sure the addStudentTriggerRow is displaying
		showAddStudentTrigger(addStudentTriggerRow);

		// make sure addStudentTrigger is disabled when at max subs
		if (canAddSubRow()) {
			enableAddStudentTrigger(addStudentTriggerRow);
		} else {
			disableAddStudentTrigger(addStudentTriggerRow);
		}

		// also kill the remove x icon because there will be at most one row on open
		wrapperEl
			.getElementsByClassName("w-form")[0]
			.classList.remove("has-many-rows");

		// reset the alertDiv
		const alertDiv = $find(wrapperEl, ".modal-alert")[0];
		alertDiv.classList.remove("success");
		alertDiv.classList.remove("error");
		const alertContent = alertDiv.querySelector(".modal-alert-content");
		if (alertContent) {
			alertContent.replaceChildren();
		}

		const firstInput = wrapper.getElementsByClassName("student-name")[0];
		const closeX = wrapperEl.getElementsByClassName("close-image")[0];
		const trapFocus = function() {
			wrapperEl.addEventListener("keydown", function(e) {
				const isTabPressed = e.key === "Tab" || e.keyCode === 9;
				if (!isTabPressed) {
					return;
				}

				if (e.shiftKey) {
					/* shift + tab */
					if (document.activeElement === firstInput) {
						closeX.focus();
						e.preventDefault();
					}
				} else {
					/* tab */
					if (document.activeElement === closeX) {
						firstInput.focus();
						e.preventDefault();
					}
				}
			});
		};
		const tryFocusFirstInput = function() {
			if (!firstInput) {
				// There will be no input if user has reached max subs.
				return;
			}
			firstInput.focus();
			// keep trying until it appears
			if (document.activeElement !== firstInput) {
				setTimeout(tryFocusFirstInput, 100);
			} else {
				trapFocus();
			}
		};
		tryFocusFirstInput();
	};

	const onClose = function() {
		didMouseDown = false;
		document.body.classList.remove("wf-modal--open");
		resetAddToCartButtons();
	};

	onModalOpen(onOpen, id);
	onModalClose(onClose, id);
}

function setupModalHandlers() {
	const modalList = [
		"enrollMonthlyModal",
		"enrollYearlyModal",
		"enrollBundleModal",
	];
	modalList.forEach(function(id) {
		const wrapper = getModalWrapperFromId(id);
		if (!wrapper) {
			return;
		}
		setupSubscriptionModal(id, wrapper);
	});
}

// the passed in element is the button that was clicked to add the code to the
// cart. It will be refocused after the modal is closed
function addSingleBulkCodeToCart(button) {
	const itemsToAdd = [{options: {}, quantity: 1, sku: "beast-bulk-codes"}];
	if (!itemsToAdd.length || itemsToAdd[0]?.quantity === 0) {
		openModalByName("noItemsSelected", button);
		return;
	}
	modifyCart(c => {
		addItemsToCart(itemsToAdd, c);
	});
	showAddToCartModal(getTotalQuantity(itemsToAdd), "code", button);
}
// Subscriptions can't be purchased with ClassWallet,
// and normally an enroll modal would show appear on the enroll page when
// clicking the cards, so we need to hijack the click handlers so we
// can direct the user to go to the For Schools page to schedule a demo
function setupForClassWallet() {
	const cwCookie = getCookie("cw");
	if (!cwCookie || document.location.pathname !== "/online/enroll") {
		return;
	}
	const subsNotAvailableModal = $find(
		document,
		".modal-wrapper.subscription-not-available"
	)[0];
	const liveClassesErrorModal = $find(
		document,
		".modal-wrapper.live-classes-error"
	)[0];
	const subscriptionClassWalletBundleModal = $find(
		document,
		".modal-wrapper.classwallet-bundle"
	)[0];

	const logCWEnrollButtonClick = el => {
		let sub_type = "";
		if (el.id === "vc-modal-open-btn") {
			sub_type = "virtual-campus";
		} else if (el.className.includes("beast-monthly")) {
			sub_type = "beast-monthly";
		} else if (el.className.includes("beast-yearly")) {
			sub_type = "beast-yearly";
		} else if (el.className.includes("beast-bundle")) {
			sub_type = "beast-bundle";
		}
		sendDataLayerEvent("classwallet_click_enroll_card", {sub_type});
	};

	// Hijack the click handlers for all of the cards
	$each(document, ".subscription-card", el => {
		const classWalletYearly = el.classList.contains(
			"classwallet-enabled-yearly"
		);
		const classWalletBundle = el.classList.contains(
			"classwallet-enabled-bundle"
		);
		el.addEventListener("click", evt => {
			if (classWalletYearly) {
				// allow this card to add a subscription code to the cart
				addSingleBulkCodeToCart(el);
				evt.preventDefault();
				evt.stopPropagation();
			} else if (classWalletBundle) {
				let modalToShow = subscriptionClassWalletBundleModal;
				if (el.id === "vc-modal-open-btn") {
					modalToShow = liveClassesErrorModal;
				}
				// prevent the card from adding a subscription to the cart
				// show a modal with error message to the user
				showModal(modalToShow, evt);
				logCWEnrollButtonClick(el);
			} else {
				let modalToShow = subsNotAvailableModal;
				if (el.id === "vc-modal-open-btn") {
					modalToShow = liveClassesErrorModal;
				}
				// prevent the card from adding a subscription to the cart
				// show a modal with error message to the user
				showModal(modalToShow, evt);
				logCWEnrollButtonClick(el);
			}
		});
	});
	// change the title text
	const title = $find(document, ".section-intro-copy .headline")[0];
	if (title) title.innerText += " with ClassWallet";
	// change the subtitle text
	const subtitle = $find(document, ".section-intro-copy .og_h2")[0];
	const linkToDemo = "https://beastacademy.com/demo/school";
	const textStyleClass = "text-dark-blue";
	if (subtitle)
		subtitle.innerHTML = `Click <a href=${linkToDemo} class=${textStyleClass}>here</a> to try the self-paced platform demo!`;

	// yearly card text changes
	const yearlyEl = $find(
		document,
		".subscription-card.classwallet-enabled-yearly"
	)[0];
	changeYearlyTextCW(yearlyEl);
}

function changeYearlyTextCW(el) {
	const cardTitle = $find(el, ".price-change-yearly-text-top")[0];
	if (cardTitle) cardTitle.innerText = "Subscription Code";

	const classWalletCardDescription =
		"1-year subscription code to Beast Academy Online";
	const cardDescription = $find(el, ".price-change-yearly-text-bottom")[0];
	cardDescription.innerHTML = classWalletCardDescription;
	cardDescription.style.marginTop = "2rem";
}

// Setup Mixpanel click handlers on elements with the data-mixpanel-event attribute.
function setupMixpanelEvents() {
	$each(document, "[data-mixpanel-event]", el => {
		const eventName = el.getAttribute("data-mixpanel-event");
		if (!eventName) {
			return;
		}
		el.addEventListener("click", e => {
			// only fire event if the click was initiated by the user
			if (!e.isTrusted) {
				return;
			}
			// grab all the other data-mixpanel-* attributes and build a properties object
			const properties = Object.entries(el.dataset).reduce(
				(acc, [attr, value]) => {
					if (attr.startsWith("mixpanel") && attr !== "mixpanelEvent") {
						const key = attr.replace("mixpanel", "");
						// convert the key to camel case
						acc[key[0].toLowerCase() + key.slice(1)] = value;
					}
					return acc;
				},
				{}
			);
			track(eventName, properties);
		});
	});
}

function setupEnroll() {
	const cwCookie = getCookie("cw");

	loadSubsFromCart();
	// Set up online subscription / bundle modal handlers
	setupModalHandlers();
	setupMixpanelEvents();
	if (cwCookie) {
		setupForClassWallet();
		handleClassWalletBundleModal();
	} else if (document.location.pathname === "/online/enroll") {
		// Set up VC modal handler

		if (document.querySelector("#vc-modal-open-btn")) {
			document.querySelector("#vc-modal-open-btn").onclick = () => {
				document.getElementById("enroll-vc-modal").classList.remove("hide");
				document.querySelector("#vc-modal-wrap").classList.add("anim-fade-in");
			};
		}

		if (document.querySelector("#vc-close-block")) {
			document.querySelector("#vc-close-block").onclick = () => {
				document.getElementById("enroll-vc-modal").classList.add("hide");
				document
					.querySelector("#vc-modal-wrap")
					.classList.remove("anim-fade-in");
			};
		}
		$each(document, ".subscription-card", el => {
			el.addEventListener("click", function(evt) {
				// Skip VC modal button - it has special handling elsewhere
				if (el.id === "vc-modal-open-btn") {
					return;
				}

				// Determine subscription type from card classes or data attribute
				let enrollType = el.dataset.mixpanelEnrollType;
				if (!enrollType) {
					if (el.classList.contains("beast-monthly")) {
						enrollType = "monthly";
					} else if (el.classList.contains("beast-yearly")) {
						enrollType = "yearly";
					} else if (el.classList.contains("beast-bundle")) {
						enrollType = "bundle";
					}
				}
				// Either we don't know the enroll type,
				// or we should let the default behavior happen. VC has its own modal
				// so let the modal open for that.
				if (!enrollType || enrollType === "vc") {
					return;
				}

				// For monthly and yearly, add directly to cart
				evt.preventDefault();
				evt.stopPropagation();

				if (!canAddSubToCart()) {
					showAddToCartModal(0, "subscription", el);
					return;
				}

				if (enrollType === "bundle") {
					showAddBundleToCartModal(getTotalQuantity(itemsToAdd), el);
					return;
				}

				const sku = enrollType === "monthly" ? "beast-monthly" : "beast-yearly";
				const cart = loadCartFromStorage();
				const subscriptionCount = (cart.items || []).reduce(
					(sum, item) =>
						item.sku === "beast-monthly" || item.sku === "beast-yearly"
							? sum + (item.quantity || 1)
							: sum,
					0
				);
				const itemsToAdd = [
					{
						sku: sku,
						quantity: 1,
						options: {
							displayName: getSubscriptionPlaceholderName(subscriptionCount),
						},
					},
				];

				if (!canAddSubToCart()) {
					showAddToCartModal(0, "subscription", el);
					return;
				}

				modifyCart(c => {
					addItemsToCart(itemsToAdd, c);
				});

				showAddToCartModal(getTotalQuantity(itemsToAdd), "subscription", el);
			});
		});

		if (document.getElementById("view-course-form")) {
			document.getElementById("view-course-form").onsubmit = () => {
				let link = "https://virtual.aopsacademy.org/courses/";
				const urlParams =
					"?utm_source=beastacademy&utm_medium=referral&utm_campaign=vc_beast_bao_enroll";
				if (document.getElementById("level2").checked) {
					link += "year-round/math-2";
				} else if (document.getElementById("level3").checked) {
					link += "year-round/math-3";
				} else if (document.getElementById("level4").checked) {
					link += "year-round/math-4";
				} else if (document.getElementById("level5").checked) {
					link += "year-round/math-5";
				} else if (document.getElementById("level-all").checked) {
					link += "catalog";
				}
				window.open(link + urlParams, "_blank");
			};
		}

		if (document.querySelector("#enroll-vc-modal")) {
			document.querySelector("#enroll-vc-modal").onclick = e => {
				const rect = document
					.querySelector("#vc-modal-wrap")
					.getBoundingClientRect();
				const inModal = (x, y) => {
					return (
						rect.left < x && x < rect.right && rect.top < y && y < rect.bottom
					);
				};

				if (!inModal(e.clientX, e.clientY)) {
					document.getElementById("enroll-vc-modal").classList.add("hide");
					document
						.querySelector("#vc-modal-wrap")
						.classList.remove("anim-fade-in");
				}
			};
		}
	}
}

module.exports = setupEnroll;
